import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { withDevice } from '@blazar-plugins/device'

import TabBar from 'components/TabBar'
import Breadcrumbs from 'components/Breadcrumbs'
import ErrorComponent from 'components/ErrorComponent'
import Footer from 'components/Footer'

import SelectionList from './SelectionList'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
`

const StyledBreadcrumbs = styled(Breadcrumbs)`
  padding-left: 16px;
`

export const SmallLayout = ({
  error,
  errorId,
  searchParametersDefinition,
  geoPref,
  filterQuery,
}) => {
  if (error) {
    return <ErrorComponent error={errorId} />
  }

  return (
    <Container>
      <TabBar />
      <StyledBreadcrumbs
        breadcrumbs={[
          { label: 'Alla', apiQuery: '/classifieds/v2/ads', searchParameters: '' },
          { label: 'Bostad' },
        ]}
        searchParametersDefinition={searchParametersDefinition}
        geoPref={geoPref}
        filterQuery={filterQuery}
      />
      <main>
        <SelectionList />
      </main>
      <Footer />
    </Container>
  )
}

SmallLayout.propTypes = {
  error: PropTypes.bool.isRequired,
  errorId: PropTypes.string,
  device: PropTypes.shape({ is: PropTypes.func.isRequired }).isRequired,
  filterQuery: PropTypes.object,
  geoPref: PropTypes.object,
  searchParametersDefinition: PropTypes.object,
}

export default withDevice(SmallLayout)
